import SideBar from "./sidebar";
import MainContainer from "./maincontaier";
const Body=()=>{
    return <div className="body">
      <SideBar/>
      <MainContainer/>
    </div>
  }
  export default Body;